<script setup>
import { useAuthStore } from '~/store/auth';
const authStore = useAuthStore();
const { $authInfo } = useNuxtApp();

onMounted(async () => {
  try {
    const info = await $authInfo();

    authStore.authenticated = info.authenticated;
    authStore.usergroups = info.groups;
    authStore.username = info.username;

    if (process.dev) {
      console.log('[AuthInit] Auth state updated from $authInfo');
    }
  } catch (error) {
    console.warn('[AuthInit] Error updating auth state:', error);
  }
});
</script>
